// extracted by mini-css-extract-plugin
export default {"beforeAnnouncement":"FinalBannerBeforeAnnouncement_beforeAnnouncement__0onsi","bannerBottomContentTitle":"FinalBannerBeforeAnnouncement_bannerBottomContentTitle__zhudb"};